// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/main.scss
// module id = 70
// module chunks = 0